(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/loader-ticket/loader-ticket.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/loader-ticket/loader-ticket.js');
"use strict";


const spinnerOptions = {
  lines: 12,
  length: 18,
  width: 5,
  radius: 12,
  corners: 1,
  rotate: 0,
  direction: 1,
  color: '#e1e1e5',
  speed: 1,
  trail: 60,
  shadow: false,
  hwaccel: true,
  className: 'spinner',
  zIndex: 1,
  top: '50%',
  left: '50%',
  delayedShow: true
};
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const Brand = svs.ui.ReactBrand;
setGlobal('svs.ticketgames.ticketUtility.components.LoaderTicket', _ref => {
  var _ticketInfo$gameLoade;
  let image = _ref.image;
  const Image = svs.content.image_v2.Image;
  const NEO_RGS = svs.ticketgames.ticketUtility.utils.constants.leia.GAME_LOADERS.NEO_RGS;
  const CUSTOM_LOADERS = [NEO_RGS];
  const gameContext = svs.ticketgames.ticketUtility.components.useGameContext();
  const ticketInfo = gameContext.ticketInfo,
    _gameContext$isFullSc = gameContext.isFullScreenGame,
    isFullScreenGame = _gameContext$isFullSc === void 0 ? false : _gameContext$isFullSc;
  const containerRef = useRef(null);
  const hasCustomLoader = CUSTOM_LOADERS.includes(ticketInfo === null || ticketInfo === void 0 || (_ticketInfo$gameLoade = ticketInfo.gameLoader) === null || _ticketInfo$gameLoade === void 0 ? void 0 : _ticketInfo$gameLoade.toUpperCase());
  const disableLoader = svs.utils.url.queryString.disableLoader;
  useEffect(() => {
    if (hasCustomLoader || disableLoader === 'true') {
      return;
    }
    const spinner = new Spinner(spinnerOptions).spin(containerRef.current);
    return () => {
      spinner === null || spinner === void 0 || spinner.stop();
    };
  }, []);
  if (disableLoader === 'true') {
    return null;
  }
  if (hasCustomLoader && isFullScreenGame) {
    var _svs$core$config$data;
    const aoBrandImgSrc = "".concat((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.cdn, "/images/components/ao-logotype-tur/ao-tur.svg");
    return React.createElement("div", {
      className: "absolute w100 h100 svs-loader-ticket-bg-fullscreen",
      "data-testid": "loader-ticket",
      ref: containerRef
    }, React.createElement("img", {
      className: "absolute u-right-0 u-top-0 svs-loader-ticket-ao-brand",
      src: aoBrandImgSrc
    }), React.createElement("div", {
      className: "h100 u-flex u-flex-justify-content-center u-flex-align-items-center"
    }, React.createElement("div", null, React.createElement(Brand, {
      brand: "svenskaspel-twolines",
      emblem: true,
      size: 500
    }), React.createElement("div", {
      className: "w100 overflow-hidden relative svs-loader-ticket-progress-container margin-top-2"
    }, React.createElement("div", {
      className: "absolute u-top-0 svs-loader-ticket-progress-bar"
    })))));
  }
  return React.createElement("div", {
    className: "ticket-overlay absolute w100 h100",
    "data-testid": "loader-ticket",
    ref: containerRef
  }, image && React.createElement(Image, {
    cssSelectors: "preview-ticket",
    image: image
  }));
});

 })(window);